// This deployment targets the scheduled structstestnet-111 upgrade only.
export const CHAIN = Object.freeze({
  ID: 'structstestnet-111',
  UPGRADE_HEIGHT: '3353000',
  LEGACY_PROTOCOL: 'v0.21.0',
  PROTOCOL: 'v0.22.0',
  API_CONTRACT: 'structs-api-v022-1',
});
